import indexOf from 'lodash/indexOf';

import store from '../../store';
import { REQUIRED } from '../../constants/validations';
import { RESIDENTIAL, COMMERCIAL, TDS, LAND } from '../../constants/typeOfHomeOptions';

const validations = values => {
  let errors = {};

  if (!values.purpose_of_loan) {
    errors.purpose_of_loan = REQUIRED;
  }

  if (!values.property_type) {
    errors.property_type = REQUIRED;
  }

  if (!values.no_of_units) {
    errors.no_of_units = REQUIRED;
  }

  if (!values.transaction_type) {
    errors.transaction_type = REQUIRED;
  }

  if (!values.use_of_funds) {
    errors.use_of_funds = REQUIRED;
  }

  if (!values.occupancy) {
    errors.occupancy = REQUIRED;
  }

  //

  //

  if (!values.occupancy_at_closing) {
    errors.occupancy_at_closing = REQUIRED;
  }

  if (!values.suburban_or_rural) {
    errors.suburban_or_rural = REQUIRED;
  }

  if (!values.coe_date) {
    errors.coe_date = REQUIRED;
  }

  if (!values.exit_strategy) {
    errors.exit_strategy = REQUIRED;
  }

  if (!values.exit_repay_loan) {
    errors.exit_repay_loan = REQUIRED;
  }

  //

  const { type_of_loan } = store.getState().form.accounts;

  if (indexOf([RESIDENTIAL.value, COMMERCIAL.value, TDS.value, LAND.value], type_of_loan) !== -1) {
    if (!values.property_income) {
      errors.property_income = REQUIRED;
    }
  }

  return errors;
};

export default validations;



// WEBPACK FOOTER //
// ./src/Screens/ConsoleBrok/validations.js